<template>
  <div class="tutorial-form">
    <el-form-item label="讲师姓名">
      <el-input v-model="form.instructorName" maxlength="64" show-word-limit placeholder="例如：Allen" />
    </el-form-item>
    <el-form-item label="讲师头衔">
      <el-input v-model="form.instructorTitle" maxlength="128" show-word-limit placeholder="例如：福州人工智能协会 高级AI讲师" />
    </el-form-item>
    <el-form-item label="讲师头像">
      <image-upload v-model="form.instructorAvatar" biz-type="cms_avatar" button-text="上传讲师头像" hint="建议竖版人像，支持 JPG/PNG/GIF/WebP，不超过 10MB" />
    </el-form-item>
    <el-form-item label="讲师介绍">
      <el-input v-model="form.instructorIntro" type="textarea" :rows="3" placeholder="介绍讲师背景与经验" />
    </el-form-item>
    <el-form-item label="适合人群">
      <el-input v-model="form.targetAudience" type="textarea" :rows="2" placeholder="例如：零基础学员、设计师、运营人员" />
    </el-form-item>
    <el-form-item label="学习目标">
      <el-input v-model="form.learningGoals" type="textarea" :rows="3" placeholder="学员学完后应掌握的能力" />
    </el-form-item>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title"><i class="el-icon-notebook-2" /> 章节管理</span>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addChapter">添加章节</el-button>
      </div>
      <div v-if="!(form.chapters || []).length" class="section-empty">暂无章节，点击右上角添加</div>
      <div v-for="(chapter, index) in (form.chapters || [])" :key="'ch-' + index" class="dynamic-card">
        <div class="card-top">
          <span class="index-badge">{{ index + 1 }}</span>
          <el-button type="text" size="mini" class="danger" @click="removeChapter(index)">删除</el-button>
        </div>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-input v-model="chapter.title" placeholder="章节标题" />
          </el-col>
          <el-col :span="12">
            <el-input v-model="chapter.duration" placeholder="时长（如 15 分钟）" />
          </el-col>
        </el-row>
        <div class="field-row">
          <span class="field-label">视频上传</span>
          <media-upload v-model="chapter.videoUrl" biz-type="cms_video" button-text="上传章节视频" />
        </div>
        <el-input
          v-model="chapter.description"
          type="textarea"
          :rows="2"
          placeholder="章节描述"
          class="field-gap"
        />
      </div>
    </div>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title"><i class="el-icon-question" /> 常见问题（FAQ）</span>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addFaq">添加 FAQ</el-button>
      </div>
      <div v-if="!(form.faqs || []).length" class="section-empty">暂无 FAQ，点击右上角添加</div>
      <div v-for="(faq, index) in (form.faqs || [])" :key="'faq-' + index" class="dynamic-card faq-card">
        <div class="card-top">
          <span class="faq-label">Q{{ index + 1 }}</span>
          <el-button type="text" size="mini" class="danger" @click="removeFaq(index)">删除</el-button>
        </div>
        <el-input v-model="faq.question" placeholder="问题" class="field-gap" />
        <el-input v-model="faq.answer" type="textarea" :rows="2" placeholder="答案" class="field-gap" />
      </div>
    </div>
  </div>
</template>

<script>
import MediaUpload from '@/components/admin/MediaUpload.vue'
import ImageUpload from '@/components/admin/ImageUpload.vue'
import { createEmptyChapter, createEmptyFaq } from '@/utils/tutorialFormat'

export default {
  name: 'TutorialArticleForm',
  components: { MediaUpload, ImageUpload },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  methods: {
    addChapter() {
      if (!this.form.chapters) {
        this.$set(this.form, 'chapters', [])
      }
      this.form.chapters.push(createEmptyChapter())
    },
    removeChapter(index) {
      this.form.chapters.splice(index, 1)
    },
    addFaq() {
      if (!this.form.faqs) {
        this.$set(this.form, 'faqs', [])
      }
      this.form.faqs.push(createEmptyFaq())
    },
    removeFaq(index) {
      this.form.faqs.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.section-block {
  margin-bottom: 20px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.section-title {
  font-weight: 600;
  color: #303133;
}
.section-title i {
  margin-right: 6px;
  color: #e6a23c;
}
.section-empty {
  padding: 20px 0;
  text-align: center;
  color: #c0c4cc;
  font-size: 13px;
}
.dynamic-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}
.card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.index-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fdf6ec;
  color: #e6a23c;
  font-size: 12px;
  font-weight: 600;
}
.faq-label {
  font-weight: 600;
  color: #606266;
}
.field-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 10px;
}
.field-label {
  flex-shrink: 0;
  width: 70px;
  line-height: 32px;
  font-size: 13px;
  color: #909399;
}
.field-gap {
  margin-top: 10px;
}
.danger {
  color: #f56c6c;
}
</style>
